export enum OutreachTableColumnId {
  Actions = "actions",
  Contacts = "contacts",
  LimitedPartner = "limitedPartner",
  Relationship = "relationship",
  Tier = "tier",
}
